import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconChevronDownSvg } from "./IconChevronDownSvg.mjs";
const IconChevronDown = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconChevronDownSvg, ...iconProps });
};
export {
  IconChevronDown
};
